import {
  ROLE_LIST_GET_LIST,
  ROLE_LIST_GET_LIST_SUCCESS,
  ROLE_LIST_GET_LIST_ERROR,
  ROLE_LIST_GET_LIST_WITH_FILTER,
  PROPERTY_LIST_GET_LIST,
  PROPERTY_LIST_GET_LIST_SUCCESS,
  PROPERTY_LIST_GET_LIST_ERROR,
  PROPERTY_LIST_GET_LIST_WITH_FILTER,
  USER_LIST_GET_LIST,
  USER_LIST_GET_LIST_SUCCESS,
  USER_LIST_GET_LIST_ERROR,
  USER_LIST_GET_LIST_WITH_FILTER,
  AGENT_LIST_GET_LIST,
  AGENT_LIST_GET_LIST_SUCCESS,
  AGENT_LIST_GET_LIST_ERROR,
  ROLE_PERMISSION,
  CHECK_MYMA_SUPER_ADMIN,
  CHECK_USER_SUPER_ADMIN,
} from '../actions';

export const ChangeMymaSuperAdmin = (role) => ({
  type: CHECK_MYMA_SUPER_ADMIN,
  payload: role,
});

export const ChangeUserSuperAdmin = (role) => ({
  type: CHECK_USER_SUPER_ADMIN,
  payload: role,
});

export const ChangeRolePermission = (role) => ({
  type: ROLE_PERMISSION,
  payload: role,
});

export const getRoleList = () => ({
  type: ROLE_LIST_GET_LIST,
});

export const getRoleListSuccess = (roles) => ({
  type: ROLE_LIST_GET_LIST_SUCCESS,
  payload: { roles },
});

export const getRoleListError = (error) => ({
  type: ROLE_LIST_GET_LIST_ERROR,
  payload: error,
});

export const getPropertyList = () => ({
  type: PROPERTY_LIST_GET_LIST,
});

export const getPropertyListSuccess = (properties) => ({
  type: PROPERTY_LIST_GET_LIST_SUCCESS,
  payload: { properties },
});

export const getPropertyListError = (error) => ({
  type: PROPERTY_LIST_GET_LIST_ERROR,
  payload: error,
});

export const getUserList = () => ({
  type: USER_LIST_GET_LIST,
});

export const getUserListSuccess = (users) => ({
  type: USER_LIST_GET_LIST_SUCCESS,
  payload: { users },
});

export const getUserListError = (error) => ({
  type: USER_LIST_GET_LIST_ERROR,
  payload: error,
});

export const getAgentsList = () => ({
  type: AGENT_LIST_GET_LIST,
});

export const getAgentsListSuccess = (payload) => ({
  type: AGENT_LIST_GET_LIST_SUCCESS,
  payload,
});

export const getAgentsListError = (error) => ({
  type: AGENT_LIST_GET_LIST_ERROR,
  error,
});
